import { render, staticRenderFns } from "./ModalTextoSimples.vue?vue&type=template&id=f48e013a"
import script from "./ModalTextoSimples.vue?vue&type=script&lang=js"
export * from "./ModalTextoSimples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports